module.exports = __webpack_public_path__ + "static/media/loading.08bc3617.gif";